import { Table, Tooltip, Progress, Card, Typography } from "antd";
import { withRouter } from "react-router-dom";
import AppLayout from "../../components/layouts/AppLayout/index";
import Loading from "../../components/loading";
import { useEffect, useRef, useState } from "react";
import PlateService from "../../app/service/plateService";
import moment from "moment";
import { Button as ButtonAntd, Modal } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import CmdService from "../../app/service/cmdService";
import { messageError, messageSuccess } from "../../components/toastr";
import AuthContext from "../../main/authenticationProvider";
import ReportsService from "../../app/service/reportsService";
import styles from './statusLinks.module.scss';
import Moment from 'moment';

export const StatusLink = () => {
  const INITIAL_TIMER = 60;
  const routePlateService = new PlateService();
  const cmdService = new CmdService();
  const reportsService = new ReportsService();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const plateSelected = useRef("");
  const [isCommandPending, setCommandPending] = useState(false);
  const [timer, setTimer] = useState(INITIAL_TIMER);

  const auth = new AuthContext();

  const columns = [
    {
      title: () => {
        return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Placa</div>
      },
      dataIndex: "plate",
      key: "plate",
      width: 90,
      align: 'center',
      filterSearch: true,
      render: (_, data) => {
        const plate = data.element.plate;
        return <Tooltip title="Placa"><div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{plate}</div></Tooltip>;
      },
    },
    {
      title: () => {
        return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Rota</div>
      },
      dataIndex: "name",
      key: "name",
      width: 100,
      align: 'center',
      render: (_, data) => {
        const route = data.element.routeName;
        return <Tooltip title="Rota"><div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{route}</div></Tooltip>;
      },
    },
    {
      title: () => {
        return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Vinculada em</div>
      },
      dataIndex: "routeLoadDate",
      key: "routeLoadDate",
      width: 130,
      align: 'center',
      render: (status, data) => {
        const dateTime = moment(data.element.routeLoadDate).format("DD/MM/YYYY, HH:mm:ss");
        const isDownloadFinished = (data.element.qtyPagesReceived / data.element.qtyPages) === 1;
        return (
          isDownloadFinished ? (
            <Tooltip title="Rota vinculada em">
              <div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{dateTime}</div>
            </Tooltip>
          )
            : (
              <Tooltip title="Vinculação de rota em andamento.">
                <div className={styles.textStyleWave}>PROCESSANDO</div>
              </Tooltip>
            )

        );
      },
    },
    {
      title: () => {
        return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Status</div>
      },
      dataIndex: "routeLoadStatus",
      key: "routeLoadStatus",
      width: 300,
      align: 'center',
      render: (status, data) => {
        const percent = ((data.element.qtyPagesReceived / data.element.qtyPages) * 100).toFixed(
          2
        );
        const dateNow = new Date();
        const dateStarted = new Date(data.element.startDate);
        const dateDiffInMs = Math.abs(dateNow - dateStarted);
        const formattedDiff = moment.utc(dateDiffInMs);

        const dateNowDays = moment();
        const dateStartedDays = moment(data.element.startDate);
        const daysDifference = dateNowDays.diff(dateStartedDays, "days");
        const isDownloadFinished = (data.element.qtyPagesReceived / data.element.qtyPages) === 1;

        return (
          <>
            {isDownloadFinished ?
              <></>
              :
              daysDifference > 0 ?
                <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px', fontWeight: 500, fontSize: '10px' }}>{`${daysDifference}dias - ${formattedDiff.hours()}h:${formattedDiff.minutes()}m:${formattedDiff.seconds()}s`}</Typography>
                :
                <Typography style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px', fontWeight: 500, fontSize: '10px' }}>{`${formattedDiff.hours()}h:${formattedDiff.minutes()}m:${formattedDiff.seconds()}s`}</Typography>
            }
            <Progress
              percent={percent}
              size="small"
              status={
                data.element.routeLoadStatus === "ERROR"
                  ? "exception"
                  : data.element.routeLoadStatus === "CONCLUDED"
                    ? "success"
                    : percent.toString() === "100.00" ?
                      "success"
                      : "active"
              }
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-8px' }}
            />
          </>
        );
      },
    },
    {
      title: () => {
        return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Ação</div>
      },
      dataIndex: "routeLoadStatus",
      key: "routeLoadStatus",
      width: 130,
      align: 'center',
      render: (status, data) => {
        const isEnableButtonStartRoute = data.element.qtyPagesReceived / data.element.qtyPages === 1;

        const isRouteStopped = data.element.routeStartStatus === "PROCESSING_STOPPED";
        const isEnableButtonStartRouteRoteirizador = data.element.roteirizador === "Habilitado";
        const isEnableButtonStartRouteSistema = data.element.devicesEnable === "Sim";
        const checkUpdateDateAndStartDate = data.element.updateDate === data.element.routeLoadDate;

        return (
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
            <Tooltip
              placement="top"
              title={
                isEnableButtonStartRoute && isEnableButtonStartRouteSistema && isEnableButtonStartRouteRoteirizador && !isCommandPending
                  ? "Rota embarcada."
                  : !isEnableButtonStartRouteSistema ? "Sistema desabilitado."
                    : !isEnableButtonStartRouteRoteirizador ? "Roteirizador desabilitado."
                      : isCommandPending ? "Comando pendente."
                        : "Download de rota em andamento."
              }
            >
              <ButtonAntd

                size="small"
                onClick={() => handleConfirmStartRoute(checkUpdateDateAndStartDate, data.element.updateDate)}
                disabled={(!isEnableButtonStartRouteRoteirizador && !isEnableButtonStartRouteSistema) ? true
                  : isCommandPending ? true
                    : isEnableButtonStartRouteRoteirizador === false ? true
                      : isEnableButtonStartRouteSistema === false ? true
                        : isEnableButtonStartRoute && !isRouteStopped ? false : true
                }
                icon={
                  isEnableButtonStartRoute && !isRouteStopped && isEnableButtonStartRouteRoteirizador && isEnableButtonStartRouteSistema && !isCommandPending ? (
                    <CheckOutlined style={{ color: "white" }} />
                  ) : (
                    <CheckOutlined style={{ color: "GrayText" }} />
                  )
                }
                style={{
                  backgroundColor: !isEnableButtonStartRoute
                    ? "#DCDBDB"
                    : !isEnableButtonStartRouteSistema ? "#DCDBDB"
                      : !isEnableButtonStartRouteRoteirizador ? "#DCDBDB"
                        : isCommandPending ? "#DCDBDB"
                          : isRouteStopped ? "#DCDBDB" : "#246192",
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  width: "150px",
                  fontSize: '12px',
                  color:
                    !isEnableButtonStartRoute
                      ? "GrayText"
                      : !isEnableButtonStartRouteSistema ? "GrayText"
                        : !isEnableButtonStartRouteRoteirizador ? "GrayText"
                          : isCommandPending ? "GrayText"
                            : isRouteStopped ? "GrayText"
                              : "white",
                }}
                children="Iniciar Rota"
              />
            </Tooltip>
          </div>

        );
      },
    },
  ];

  const checkPendingCommand = (pendingCommands) => {
    if (pendingCommands.length !== 0) {
      for (let i = 0; i < pendingCommands.length; i++) {
        if (pendingCommands[i].cmdType.substring(0, 5) === "$CMD," &&
          (pendingCommands[i].cmdType.substring(5, 12) === "Disable" ||
            pendingCommands[i].cmdType.substring(5, 10) === "Block")) {
          setCommandPending(true);
          return;
        }
        if (pendingCommands[i].cmdType.substring(0, 4) === "$ST," && (
          pendingCommands[i].cmdType.substring(4, 5) === "0" ||
          pendingCommands[i].cmdType.substring(6, 7) === "0" ||
          pendingCommands[i].cmdType.substring(14, 15) === "0" ||
          pendingCommands[i].cmdType.substring(18, 19) === "0" ||
          pendingCommands[i].cmdType.substring(23, 24) === "0" ||
          pendingCommands[i].cmdType.substring(25, 26) === "0"

        )) {
          setCommandPending(true);
          return;
        }
      }

    }
    setCommandPending(false);
  };


  const handleSendStartRoute = () => {
    const data = {
      plate: plateSelected.current,
    };
    cmdService
      .sendRoute(data, "start")
      .then((response) => {
        if (response.data.status === 200) {
          messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
          getStatusLinkRoutePlate();
        } else {
          messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
        }
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  const handleConfirmStartRoute = (checkDates, updateDate) => {
    if (checkDates) {
      Modal.confirm({
        title: "Iniciar Rota.",
        content: "Deseja realmente iniciar a rota?",
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk() {
          handleSendStartRoute();
        },
      });
    } else {
      Modal.confirm({
        title: "ATENÇÃO! Esta rota foi atualizada em momento posterior ao de vinculação com esta placa.",
        content: 'Efetue o download da rota atualizada ou, caso deseje prosseguir ainda assim, clique em "Confirmar".',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk() {
          handleSendStartRoute();
        },
        width: 750
      });
    }

  };

  const getStatusLinkRoutePlate = () => {
    let list = [];
    routePlateService
      .getLinkLoadRoute()
      .then((response) => {
        response.data.data.forEach((element, index) => {
          if (
            (element.routeLoadStatus === "PROCESSING" ||
              element.routeLoadStatus === "CONCLUDED" ||
              element.routeLoadStatus === "INITIATED" ||
              element.routeLoadStatus === "ERROR") &&
            (element.routeStartStatus === "CREATED" ||
              element.routeStartStatus === "STOPPED" ||
              element.routeStartStatus === "PROCESSING_STOPPED")
          ) {
            list.push({ key: index, element: element });
          }
        });

        let promises = list.map((value, index) => {
          return cmdService.getStatusPlate(value.element.plate)
            .then((response) => {
              const roteirizador =
                response.data.data.roteirizador &&
                  response.data.data.roteirizador.substring(0, 1) === "0"
                  ? "Desabilitado"
                  : "Habilitado";
              const devicesEnable = response.data.data.devicesHabilitado.substring(0, 1) === "0" ? "Não" : "Sim";

              const filter = {
                "plateStr": value.element.plate,
                "startDate": Moment().subtract(22, 'days').format('YYYY-MM-DD HH:mm:ss'),
                "endDate": Moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
              };
              return reportsService.getCommands(filter).then((response) => {
                const pendingCommands = response.data.data.filter((value) => ((value.responseCmd == null || value.responseCmd == undefined || value.responseCmd === "") && value.received === false))
                const newData = {
                  plate: value.element.plate,
                  qtyPages: value.element.qtyPages,
                  qtyPagesReceived: value.element.qtyPagesReceived,
                  routeDownloadAttempts: value.element.routeDownloadAttempts,
                  routeLoadDate: value.element.routeLoadDate,
                  routeLoadStatus: value.element.routeLoadStatus,
                  routeName: value.element.routeName,
                  routeStartStatus: value.element.routeStartStatus,
                  startDate: value.element.startDate,
                  roteirizador: roteirizador,
                  devicesEnable: devicesEnable,
                  pendingCommands: pendingCommands,
                  updateDate: value.element.updateDate
                };
                checkPendingCommand(newData.pendingCommands);
                return { key: index, element: newData };
              }).catch((error) => {
                console.log("Error", error);
                return null;
              });

            })
            .catch((erros) => {
              if (erros && erros.response) {
                auth.verifyAuth(erros.response.status);
              }
              return null;
            });
        });

        Promise.all(promises).then((results) => {
          const finalList = results.filter((result) => result !== null);
          setData(finalList);
          setLoading(false);
        });
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const handleRowClicked = (row) => {
    plateSelected.current = row.element.plate;
  };



  useEffect(() => {
    let interval = null;
    if (loading) {
      getStatusLinkRoutePlate();
    }


    if (timer >= 0) {
      interval = setInterval(() => setTimer(timer => timer - 1), 1000);
    } else {
      clearInterval(interval);
      setTimer(INITIAL_TIMER);
      getStatusLinkRoutePlate();
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <>
      <AppLayout>
        {loading ? (
          <Loading />
        ) : (
          <Card title="Vínculos" bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }} style={{ height: '100%' }}>
            <Table
              style={{ height: '100%' }}
              locale={{ emptyText: "Sem vínculos." }}
              scroll={{ x: "max-content" }}
              size="small"
              loading={loading}
              dataSource={data}
              columns={columns}
              pagination={true}
              rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
              onRow={(record) => {
                return {
                  onClick: () => {
                    handleRowClicked(record);
                  },
                };
              }}
            />
          </Card>
        )}
      </AppLayout>
    </>
  );
};

export default withRouter(StatusLink);